<template>
  <div class="schedule-contain">
    <van-sticky>
      <van-nav-bar
        :style="{ paddingTop: statusBarHeight, backgroundColor: '#FFFFFF' }"
        title="退款/售后进度"
        left-arrow
        @click-left="handleBack('back')"
        class="reset-nav-bar"
      />
    </van-sticky>
    <div class="schedule-main">
      <div class="title-box">
        <div class="title">
          <img src="../asset/images/achieve-icon.png" alt="" />
          <span>{{
            statusTitles.applicationStateTitle[refundList.applicationState]
          }}</span>
        </div>
        <div class="desc">
          {{ statusTitles.statusTitle[refundList.applicationState] }}
        </div>
      </div>
      <div class="schedule-info">
        <div class="head-title">退款信息</div>
        <div class="goods-box">
          <div class="goods-img">
            <img :src="refundList.goodsPic" alt="" />
            <div class="goods-type">
              {{ statusTitles.goodsKindsTitle[refundList.goodsKinds] }}
            </div>
          </div>
          <div class="goods-info">
            <div class="goods-name">
              {{ refundList.goodsName }}
            </div>
            <div class="specification">
              <span
                class="spec-item"
                v-for="(item, index) in refundList.skuInfo"
                :key="index"
                >{{ item }}</span
              >
            </div>
            <div class="goods-price">
              <div class="price">￥{{ refundList.goodsPrice }}</div>
              <div class="amount">×{{ refundList.num || 1 }}</div>
            </div>
          </div>
        </div>
      </div>
      <ul class="reason-info">
        <li class="reason-item">
          <span class="name">退款原因</span>
          <span class="reason">{{
            statusTitles.refundCauseTitle[refundList.refundCause]
          }}</span>
        </li>
        <li class="reason-item">
          <span class="name">退款金额</span>
          <span class="reason">{{ refundList.refundMoney? `￥${refundList.refundMoney}` : '——' }}</span>
        </li>
        <li class="reason-item">
          <span class="name">申请时间</span>
          <span class="reason">{{ refundList.createTime }}</span>
        </li>
        <li class="reason-item">
          <span class="name">退款编号</span>
          <span class="reason">{{ refundList.refundNo }}</span>
        </li>
      </ul>
      <div class="cut-line"></div>
      <div class="logistics-info">
        <div class="head-title">审核记录</div>
        <div
          class="logistics-item"
          v-for="(item, index) in refundList.processList"
          :key="index"
          v-show="item.status !=2"
        >
          <div class="date-time">
            <p class="time">{{ item.obj.isDate? item.obj.isDate: item.obj.createTime.split(" ")[1] }}</p>
            <p class="date">{{ item.obj.isDate? item.obj.createTime.split(" ")[1]: item.obj.createTime.split(" ")[0] }}</p>
          </div>
          <div
            class="sign-line"
            :style="{
              width: index == refundList.processList.length - 1 ? 0 : '1px',
            }"
          >
            <div
              class="sign"
              :style="{ backgroundColor: index == 0 ? '#1F94FF' : '#DCDDDC' }"
            >
              <img
                class="sign sign-img"
                src="../asset/images/success-icon.png"
                alt=""
                v-if="item.status === 8"
              />
              <img
                class="sign sign-img"
                src="../asset/images/fail-icon.png"
                alt=""
                v-if="item.status === 9"
              />
            </div>
          </div>
          <div class="info" :style="{ color: index == 0 ? '#333333' : '#999' }">
            <p v-if="item.status != 0 && item.status != 9">
              {{ statusTitles.recordTitle[item.status] }}
            </p>
            <p v-if="item.status == 0">
              {{
                refundList.applicationType
                  ? "您的退款退货服务单已提交成功，待售后审核中"
                  : "您的退款服务单已提交成功，待售后审核中"
              }}
            </p>
            <p v-if="item.status == 9">
              {{item.obj.curStatus == 0? refundList.applicationType? '您的退货退款申请被拒绝': '您的退款申请被拒绝' :
                statusTitles.refundTitle[item.obj.curStatus] || '您的退款申请被拒绝'
              }}
            </p>
            <p class="refuse-reson" v-if="item.status == 9">
                拒绝理由：{{item.obj.remark}}
            </p>
            <ul class="user-info" v-if="item.status == 1">
              <li>
                <span>收货人：</span> <span>{{ item.obj.userName }}</span>
              </li>
              <li>
                <span>收货电话：</span> <span>{{ item.obj.userPhone }}</span>
              </li>
              <li>
                <span>收货地址：</span>
                <span>{{
                  item.obj.provinceName +
                  item.obj.cityName +
                  item.obj.countyName +
                  item.obj.addr
                }}</span>
              </li>
            </ul>
            <div
              class="edit-addr-info-btn"
              v-if="item.status == 1"
              @click="editAddrInfo(item.obj)"
              :style="{
                  'color': refundList.applicationState == 1 || refundList.applicationState == 2 ? '#1F94FF': '#D8D8D8',
                  'border-color': refundList.applicationState == 1 || refundList.applicationState == 2 ?
                  '#1F94FF' : '#D8D8D8;'
              }"
            >
              {{item.obj.hasDeliveryTag? '修改退货信息': '填写退货信息'}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="showEdit" title="请填写退货单号信息">
      <van-form>
        <van-field
          v-model="userInfo.userName"
          readonly
          name="收货人"
          label="收货人"
          placeholder="请填写收货人"
        />
        <van-field
          v-model="userInfo.userPhone"
          readonly
          name="联系电话"
          label="联系电话"
          placeholder="请填写联系电话"
        />
        <van-field
          class="address-box"
          v-model="userInfo.address"
          readonly
          name="收货地址"
          label="收货地址"
          placeholder="请填写收货地址"
        >
        <template #input>
            <span>{{userInfo.address}}</span>
        </template>
        </van-field>
        <van-field
          required
          readonly
          name="快递公司"
          label="快递公司"
          v-model="expressCompony"
          placeholder="请选择快递公司"
          @click="showPopup"
        >
          <template #button>
            <div class="popup-box" v-if="showPopover">
              <ul class="company-box">
                <li
                  v-for="(item, index) in companyNameLists"
                  :key="index"
                  @click.stop="getComponyName(item)"
                >
                  {{ item.name }}
                </li>
              </ul>
              <!-- <div class="rotate"></div> -->
            </div>
            <img class="right-icon" src="../asset/images/right.png" alt="" />
          </template>
        </van-field>
        <van-field
          required
          v-model="expressNo"
          name="快递单号"
          label="快递单号"
          placeholder="请填写快递单号"
        />
        <p></p>
      </van-form>
      <div class="submit-box">
        <div class="submit-btn" @click="submitInfo">提交</div>
      </div>
    </van-action-sheet>
    <div class="safe-box" 
    :style="{
        paddingTop: bottomSafeHeight
    }"></div>
  </div>
</template>

<script>
import statusTitles from '../libs/statusTitle.js'
export default {
  data() {
    return {
      showEdit: false,
      showPopover: false,
      statusBarHeight: 0,
      bottomSafeHeight: 0,
      refundList: {}, // 详情数据
      statusTitles: statusTitles,
      companyNameLists: [], // 快递公司信息
      userInfo: {}, // 修改快递  联系人方式
      username: '',
      showPopuper: true,
      expressCompony: '', // 快递公司名称
      expressNo: '', // 快递单号
    };
  },
  mounted() {
    this.setCompatible();
    this.getExpressCompanyList()
    this.getData()
  },
  methods: {
    setCompatible() {
      if (localStorage.getItem("type") == "iOS") {
        this.statusBarHeight = `${
          localStorage.getItem("statusBarHeight") || 0
        }px`;
        this.bottomSafeHeight = `${
          localStorage.getItem("bottomSafeHeight") || 0
        }px`;
      }
    },
    showPopup(){
        this.showPopover = true
    },

    // 判断今天 昨天
 showText (timeString) {
     let times = timeString.replaceAll('-', '/')
     console.log('-------timeString', times)
  let date = new Date(times)
  let today = new Date()
  today.setHours(0)
  today.setMinutes(0)
  today.setSeconds(0)
  // today 为今天凌晨的时间
  let dayTime = 24 * 60 * 60 * 1000
  let delta = today - date // 得到相差的时间 ms
  if (delta > 0) {
    if (delta <= dayTime) {
      return '昨天'
    } else if (delta <= 2 * dayTime) {
      return '前天'
    }
  } else if (-delta < dayTime) {
    return '今天'
  }
  return timeString
},
    getData(){
        this.$api.applyRefund.refundProcess({
            orderId: this.$route.query.orderId
        }).then(res=>{
            this.refundList = res.data
            this.refundList.processList.map(item=>{
                if(this.showText(item.obj.createTime) == '今天' || this.showText(item.obj.createTime) == '昨天'){
                    item.obj.isDate = this.showText(item.obj.createTime)

                } else {
                    item.obj.isDate = ''
                }
                if(item.status == 7){
                    this.refundList.processList.push({
                        status: 8,
                        obj: item.obj
                    })
                }
            })
            this.refundList.processList.reverse()
        })
    },
    getExpressCompanyList(){
        this.$api.applyRefund.findExpressCompanyList().then(res=>{
            if(res.success){
                this.companyNameLists = res.data || [];
            }
        })
    },
    getComponyName(item){
        
        this.expressCompony = item.name
        
        this.$nextTick(()=>{
          this.showPopover = false
        })
        this.showPopover = false
    },
    editAddrInfo(item){
        if(this.refundList.applicationState != 1 && this.refundList.applicationState != 2) return 
        this.userInfo = item
        this.userInfo.address = item.provinceName + item.cityName + item.countyName + item.addr
        this.expressCompony = item.deliveryCompany
        this.expressNo = item.deliveryNo
        this.showEdit = true
    },

    submitInfo(){
        if(!this.expressCompony){
            this.$toast('请选择快递公司')
            return
        }
        if(!this.expressNo){
            this.$toast('请填写快递单号')
            return
        }
        this.$api.applyRefund.postInfoSubmit({
            curStatus: this.refundList.applicationState,
            deliveryCompany: this.expressCompony,
            deliveryNo: this.expressNo,
            // id: this.$route.query.id
            id: this.refundList.refundId
        }).then(res=>{
            if(res.success){
                this.$toast('提交成功')
                this.getData()
                this.showEdit = false
            }
        })
    },

    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less">
@import "../asset/css/refundSchedule.less";
</style>
